import { render, staticRenderFns } from "./BadgeAwardWidget.vue?vue&type=template&id=23fa58fc&scoped=true"
import script from "./BadgeAwardWidget.vue?vue&type=script&lang=js"
export * from "./BadgeAwardWidget.vue?vue&type=script&lang=js"
import style0 from "./BadgeAwardWidget.vue?vue&type=style&index=0&id=23fa58fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fa58fc",
  null
  
)

export default component.exports